import { NONE } from '../constants/CallTopics';
import { utterancePillSimplifier } from '../utils/mediaTimelineUtils';
function getDominantTopic(callTopics) {
  if (!callTopics || !callTopics.length || callTopics[0].name === NONE) {
    return null;
  }
  const sortedTopics = callTopics.reduce((topicA, topicB) => topicA.prediction > topicB.prediction ? topicA : topicB).name;
  return sortedTopics;
}
export function generateCallTopics(utterances, durationInSeconds) {
  const callTopicInstances = utterances.map(utterance => ({
    startTimeSeconds: utterance.startTimeSeconds,
    endTimeSeconds: utterance.endTimeSeconds,
    callTopicId: utterance.callTopics && getDominantTopic(utterance.callTopics) || null
  })).filter(utterance => !!utterance.callTopicId).sort((a, b) => {
    return a.startTimeSeconds - b.startTimeSeconds;
  });
  return utterancePillSimplifier({
    pills: callTopicInstances,
    durationInSeconds,
    identityProperty: 'callTopic'
  });
}
export const findCurrentCallTopicUtterance = (CallTopicUtterances, currentTime) => {
  // If the array is empty, return null
  if (CallTopicUtterances.length === 0) return null;

  // If the current time is less than the start time of the first utterance,
  // return the first utterance
  if (currentTime < CallTopicUtterances[0].startTimeSeconds) {
    return CallTopicUtterances[0];
  }
  return CallTopicUtterances.slice().reverse().find(topicExcerpt => topicExcerpt.startTimeSeconds <= Math.ceil(currentTime)) || null;
};